import React from "react";
import leftArrow from "../../assets/ icon _arrow_left.png";
import rightArrow from "../../assets/ icon _arrow_right.png.png";
import SkillButton from "../skills/skillButton";
import SkillsDescriptions from "../skills/SkillsDescriptions";
import blogImage from "../../assets/blog-img.png";

const Blog = () => {
  return (
    <>
      <div
        id="blog"
        className="bg-blog h-[100vmin] bg-fill bg-no-repeat text-white  pt-12 px-[4.4rem]"
      >
        <h2 className="m-4 text-[5vmin] font-bold">Blog</h2>
        <div className="grid justify-center grid-cols-3 mt-12 ">
          <div>
            <div className="pl-36 h-[24vmin]  rounded-3xl">
              <img
                src={blogImage}
                className="w-[100%] h-[100%] object-cover rounded-3xl"
                alt=""
              />
            </div>
            <div className="pl-36">
              <div className=" h-[17vmin] border-2 border-sky-500 rounded-3xl text-center px-4 py-2 bg-[#1E1E1E] grid items-center backdrop-blur bg-white/10">
                {/* <img
                src={blogImage}
                className="w-[100%] h-[100%] object-cover border-2 rounded-3xl"
                alt=""
              /> */}
                <div className="contents">
                  <h2 className="text-[16px] font-bold">
                    AI: Revolutionising Environmental Conservation and
                    Sustainability
                  </h2>
                </div>
                <div>
                  <p className="text-[12px]">
                    Artificial intelligence, often referred to as AI, is the
                    development of computer systems that can perform tasks that
                    would typically require human intelligence. From machine
                    learning to natural language processing,{" "}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div className="px-16 h-[24vmin]  rounded-3xl">
              <img
                src={blogImage}
                className="w-[100%] h-[100%] object-cover rounded-3xl"
                alt=""
              />
            </div>
            <div className="px-16">
              <div className="px-8 h-[17vmin] border-2 border-sky-500 rounded-3xl text-center py-2 bg-[#1E1E1E] grid items-center">
                {/* <img
                src={blogImage}
                className="w-[100%] h-[100%] object-cover border-2 rounded-3xl"
                alt=""
              /> */}
                <div className="contents">
                  <h2 className="text-[16px] font-bold">
                    AI: Revolutionising Environmental Conservation and
                    Sustainability
                  </h2>
                </div>
                <div>
                  <p className="text-[12px]">
                    Artificial intelligence, often referred to as AI, is the
                    development of computer systems that can perform tasks that
                    would typically require human intelligence. From machine
                    learning to natural language processing,{" "}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div className="pr-36 h-[24vmin]  rounded-3xl ">
              <img
                src={blogImage}
                className="w-[100%] h-[100%] object-cover rounded-3xl"
                alt=""
              />
            </div>
            <div className="pr-36">
              <div className=" h-[17vmin] border-2 border-sky-500 rounded-3xl text-center px-4 py-2 bg-[#1E1E1E] grid items-center">
                {/* <img
                src={blogImage}
                className="w-[100%] h-[100%] object-cover border-2 rounded-3xl"
                alt=""
              /> */}
                <div className="contents">
                  <h2 className="text-[16px] font-bold">
                    AI: Revolutionising Environmental Conservation and
                    Sustainability
                  </h2>
                </div>
                <div>
                  <p className="text-[12px]">
                    Artificial intelligence, often referred to as AI, is the
                    development of computer systems that can perform tasks that
                    would typically require human intelligence. From machine
                    learning to natural language processing,{" "}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="grid justify-center mt-16">
          <button className="px-12 py-4 border-4 rounded-full">
            View More Work
          </button>
        </div>
      </div>
    </>
  );
};

export default Blog;
